import { createMuiTheme, Theme } from '@material-ui/core';

// https://www.materialui.co/icons?s= <-- Matrial UI Icons Search Thing

const defaultTheme: Theme = createMuiTheme({
	palette: {
		primary: {
			main: '#544a4c'
		},
		secondary: {
			main: '#ed4a68'
		}
	},
	typography: {
		fontFamily: 'roboto'
	}
});

export default defaultTheme;


// WEBPACK FOOTER //
// ./src/materialTheme.ts